import React from 'react';
import FileBase64 from 'react-file-base64';
import 'whatwg-fetch';
import file_upload_rules from '../../data/file-upload-rules';

import ModalConfirm from '../components/modal/modalConfirm';

import fileIcon from '../../images/icons/file.svg';
import ringAnim from '../../images/anim/ring.svg';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';
const apiAddDossier = '/api/stepCommercial/addExOperatorBillToFileForProd'; // post request
const apiRemoveFileDossier = '/api/stepCommercial/removeExOperatorBillToFileForProd/';

class AppDossier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entity: undefined, // products displayed inside the table
      textModal: {
        title: undefined,
        message: undefined,
      },
      isModalDeleteOpen: false,
      fileToDeleteId: undefined,
      fileInputs: [],
      files: [],
      savedFiles: undefined,
      uploadState: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openModalDeleteFile = this.openModalDeleteFile.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.removeRowBill = this.removeRowBill.bind(this);
    this.addRowBill = this.addRowBill.bind(this);
    this.postDossier = this.postDossier.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiDealShow;
      let graphQL =
        '{ deal(id:' +
        paramsID +
        '){ id, name, dateCreate, desiredClotureDate, ' +
        'stepCommercial{ id, fileForProd{ exOperatorBills{ id, name } }, intermediateStageNumber, proposition{ id, pdc }, commercialEmployee{ user{ id, username } } }, ' +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['deal']) {
              if (
                !data['data']['deal']['stepCommercial']['fileForProd']['exOperatorBills'] ||
                data['data']['deal']['stepCommercial']['fileForProd']['exOperatorBills'].length == 0
              ) {
                this.addRowBill();
              }
              this.setState({
                entity: data['data']['deal'],
                savedFiles: data['data']['deal']['stepCommercial']['fileForProd']['exOperatorBills'],
              });
            } else {
              this.props.openToast(false, 'Affaire non-trouvée');
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch deal entity: \n' + error);
          }.bind(this)
        );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  addRowBill() {
    let newInput = `input-${this.state.fileInputs.length}`;
    this.setState({
      fileInputs: this.state.fileInputs.concat([newInput]),
    });
  }

  removeRowBill(key) {
    let new_fileInputs = this.state.fileInputs;
    new_fileInputs.splice(this.state.fileInputs.indexOf(key), 1);
    this.setState({
      fileInputs: new_fileInputs,
    });
  }

  // Callback~
  getFiles(key, files) {
    let fileValid = true;
    console.log(files);
    if (files.file.size > file_upload_rules.sizeLimit) {
      // file too big
      this.props.openToast(false, 'La taille maximale autorisée est de 3Mo');
      fileValid = false;
    } else if (file_upload_rules.acceptedTypes.indexOf(files.file.type) === -1) {
      // file type not accepted
      this.props.openToast(false, 'Les formats autorisés sont jpeg, png et pdf');
      fileValid = false;
    }

    if (fileValid) {
      let newFiles = this.state.files;
      newFiles[parseInt(key.split('-')[1])] = files; // we need an int as the key
      this.setState({ files: newFiles });
      console.log(newFiles);
      console.log(key);
    }
  }

  render() {
    // PDC = (marge totale FAS) + (marge totale RM * 12 mois)
    const { savedFiles } = this.state;

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          goBack={this.props.history.goBack}
          actionButton={
            <button type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Visite Tech</span>
            </button>
          }
          title='Dossier-Prod'
        />

        <div id='appViewContent' className='listRefScroll'>
          <div className='alignHorizontal panelAppViewCat'>
            <img src={fileIcon} />
            <h6>Documents</h6>
            <button onClick={() => this.addRowBill()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'></span>
            </button>
            {this.state.uploadState == 'onGoing' && (
              <div className='alignHorizontal'>
                <img src={ringAnim} />
              </div>
            )}
            {this.state.uploadState == 'done' && <span className='icon icon-check'>Sauvegardé</span>}
            {this.state.uploadState == 'failed' && <span className='icon icon-cross'>Erreur</span>}
          </div>
          <div>
            {savedFiles ? (
              savedFiles.map((data) => (
                <div className='alignHorizontal'>
                  <a target='_blank' href={'/' + data.name}>
                    <span className='icon icon-attachment'>
                      {data.name.split('/')[data.name.split('/').length - 1]}
                    </span>
                  </a>
                  <button
                    onClick={() => this.openModalDeleteFile(data.id)}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-cross'></span>
                  </button>
                </div>
              ))
            ) : (
              <div className='alignHorizontal'>
                <span>Chargement...</span>
              </div>
            )}
            {this.state.fileInputs.map((fileInput) => (
              <div className='alignHorizontal'>
                <FileBase64
                  key={fileInput}
                  className='btn btn-sm btn-outline-success'
                  multiple={false}
                  onDone={this.getFiles.bind(this, fileInput)}
                />
                <button
                  onClick={() => this.removeRowBill(fileInput)}
                  type='button'
                  className='btn btn-sm btn-outline-success'
                >
                  <span className='icon icon-cross'></span>
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className='appViewTotal flexEnd appViewFixed'>
          <div className='alignHorizontal'>
            <button onClick={this.handleSubmit} type='button' className='btn btn-sm btn-success'>
              <span className='icon icon-document'>Sauvegarder</span>
            </button>
          </div>
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteOpen}
          onSubmit={() => this.deleteFile()}
          onClose={() => this.closeModal()}
          onCancel={() => this.closeModal()}
        ></ModalConfirm>
      </div>
    );
  }

  openModalDeleteFile(id) {
    let modalText = {
      title: 'Suppression fichier',
      message: 'Vous allez supprimer ce fichier de la commande',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modalText,
      fileToDeleteId: id,
      isModalDeleteOpen: true,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({ isModalDeleteOpen: false });
  }

  deleteFile() {
    this.setState({ uploadState: 'onGoing' });
    let json = {
      exOperatorBill: {
        id: this.state.fileToDeleteId,
      },
    };
    let queryURL = apiRemoveFileDossier;
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          // perform setState here
          let isValid = data.isValid;
          console.log(data);
          if (isValid) {
            this.componentDidMount();
            this.setState({ uploadState: undefined });
            this.props.openToast(true, 'Vous venez de supprimer le fichier');
          } else {
            this.setState({ uploadState: 'failed' });
            this.props.openToast(false, 'Erreur suppression fichier. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.setState({ uploadState: 'failed' });
          this.props.openToast(false, 'Suppression impossible');
          console.log(rror);
        }.bind(this)
      );
  }

  handleSubmit() {
    // Fetch Post
    console.log('Files to send');
    for (let i = 0; i < this.state.files.length; i++) {
      if (this.state.files[i]) {
        console.log(this.state.files[i]);
        let fileToSend = {
          type: this.state.files[i].type.split('/')[1],
          filename: this.state.files[i].name,
          base64: this.state.files[i].base64.split('base64,')[1],
        };
        this.postDossier(fileToSend, i);
      }
    }
    //this.props.openToast(true, "Bon de Commande sauvegardé.");
    //this.props.history.push("/dashboard/deal/"+this.props.match.params.id);
  }

  postDossier(file, id) {
    // file is the "file type" + "the base 64 file"
    this.setState({ uploadState: 'onGoing' });
    let payload = {
      deal: {
        id: this.props.match.params.id,
      },
      exOperatorBill: {
        typeOfFile: file.type,
        filename: file.filename,
      },
    };
    //console.log(JSON.stringify( payload ));
    let data = 'metadata=' + encodeURIComponent(JSON.stringify(payload));
    data += '&';
    data += 'base64=' + encodeURIComponent(file.base64);
    /*data.append( "metadata", encodeURIComponent(JSON.stringify( payload )) ); // the metadata
        data.append( "base64", encodeURIComponent(this.state.files.base64.split(",")[1]) ); // the base64 file
        */
    this.props
      .authFetch(apiAddDossier, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          // perform setState here
          let isValid = data.isValid;
          console.log(data);
          if (isValid) {
            this.componentDidMount();
            this.setState({ uploadState: 'done' });
            this.props.openToast(true, 'Vous venez de sauvegarder le Dossier Prod');
            let fileInputKey = 'input-' + id;
            this.state.fileInputs.splice(this.state.fileInputs.indexOf(fileInputKey), 1); // remove file after
            this.state.files.splice(id, 1); // remove file after
          } else {
            this.setState({ uploadState: 'failed' });
            this.props.openToast(false, 'Erreur sauvegarde. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          console.log(rror);
          this.setState({ uploadState: 'failed' });
        }.bind(this)
      );
  }
}

export default withAuth(AppDossier);
